import { z } from "zod";

export const subCategoryResultSchema = z.object({
  id: z.number(),
  content: z.string(),
  score: z.number().nullable(),
  proposal_note: z.string().nullable(),
});

export type SubCategoryResult = z.infer<typeof subCategoryResultSchema>;